import React, { Fragment, useState } from 'react';
import TypeAhead from "./TypeAhead";
import FormLink from "./FormLink";
import { FormGroupErrorMessage } from "../layout/Wrapper";
import FormGroupHeader from "./FormGroupHeader";
import FormGroupInput from "./FormGroupInput";
import { bankLookup } from "../../modules/api";
import Bank from "../display/Bank";
export default function BankInput({ onChange, bank = {}, error }) {
    const [manual, setManual] = useState(false); // Derive selectionMade from bank prop
    const selectionMade = !!(bank && bank.name);
    const toggleManualEntry = e => { e.preventDefault(); onChange({}); setManual(!manual); };
    const reset = e => { e.preventDefault(); setManual(false); onChange({}); };
    const setBankState = newBank => { onChange(newBank); };
    const setCustomBank = e => { e.preventDefault(); onChange({ name: e.target.value, id: null, organisation: null }); };
    const renderManualEntry = () => { return /*#__PURE__*/ React.createElement(Fragment, null, /*#__PURE__*/ React.createElement(FormGroupHeader, { label: "Bank name" }), /*#__PURE__*/ React.createElement(FormGroupInput, { name: "name", type: "text", id: 'bank_name', defaultValue: bank.name, onChange: setCustomBank }), error && /*#__PURE__*/ React.createElement(FormGroupErrorMessage, null, error), /*#__PURE__*/ React.createElement(FormLink, { text: "Use the bank lookup instead", onClick: toggleManualEntry })); };
    const renderSelectedBank = () => { const label = bank.name; const microcopy = bank.trading_name || ''; return /*#__PURE__*/ React.createElement(Fragment, null, /*#__PURE__*/ React.createElement(Bank, { label: label, microcopy: microcopy }), /*#__PURE__*/ React.createElement(FormLink, { text: "This isn't the correct bank", onClick: reset })); };
    if (manual) {
        return renderManualEntry();
    }
    else if (selectionMade) {
        return renderSelectedBank();
    }
    else {
        return /*#__PURE__*/ React.createElement(TypeAhead, { lookupFunction: bankLookup, label: "Bank lookup", onSelection: setBankState, placeholder: "Search by name (e.g. NatWest)", error: error }, /*#__PURE__*/ React.createElement(FormLink, { text: "Enter the name manually instead", onClick: toggleManualEntry }));
    }
}
